
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"#010002","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10zm0-18.4c4.632 0 8.4 3.768 8.4 8.4 0 4.632-3.768 8.4-8.4 8.4-4.632 0-8.4-3.768-8.4-8.4 0-4.632 3.768-8.4 8.4-8.4z"}}),_c('path',{attrs:{"d":"M8.14 14.717a1 1 0 001-1v-7.6a1 1 0 10-2 0v7.6a1 1 0 001 1zM12.14 14.717a1 1 0 001-1v-7.6a1 1 0 10-2 0v7.6a1 1 0 001 1z"}})])
          )
        }
      }
    